import { User, UserConfig } from "../models/User"

export const createUser = (raw: UserConfig): User => {
  return new User(raw)
}
